"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("../../../utils/styled-components"));

var _utils = require("../../../utils");

var _classnames = _interopRequireDefault(require("classnames"));

require("./StyledBox.scss");

require("./StyledBoxOffset.scss");

var _excluded = ["grid", "className", "Component", "onClick", "onBlur", "onFocus", "children", "innerRef"];

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // alignSelf style


var ALIGN_MAP = {
  baseline: "baseline",
  center: "center",
  end: "flex-end",
  start: "flex-start",
  stretch: "stretch"
};

var alignStyle = function alignStyle(props) {
  return " align-items: ".concat(function (props) {
    return ALIGN_MAP[props.align];
  }, ";");
}; // alignContent style


var ALIGN_CONTENT_MAP = {
  around: "around",
  between: "between",
  center: "center",
  end: "flex-end",
  start: "flex-start",
  stretch: "stretch"
};

var alignContentStyle = function alignContentStyle(props) {
  return "align-content: ".concat(ALIGN_CONTENT_MAP[props], ";");
}; // justifyContent style


var JUSTIFY_MAP = {
  around: "space-around",
  between: "space-between",
  center: "center",
  end: "flex-end",
  evenly: "space-evenly",
  start: "flex-start"
};

var justifyStyle = function justifyStyle(props) {
  return "justify-content: ".concat(JUSTIFY_MAP[props]);
}; // flexDirection style
// min-width and min-height needed because of this
// https://stackoverflow.com/questions/36247140/why-doesnt-flex-item-shrink-past-content-size


var directionStyle = function directionStyle(direction, theme) {
  var styles = [(0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      flex-direction: ", ";\n    "])), !direction ? "" : direction === "row-responsive" ? "row" : direction)];

  if (direction === "row-responsive" && theme.box.responsiveBreakpoint) {
    var breakpoint = theme.global.breakpoints[theme.box.responsiveBreakpoint];

    if (breakpoint) {
      styles.push((0, _utils.breakpointStyle)(breakpoint, "\n                    flex-direction: column;\n                    flex-basis: auto;\n                    justify-content: flex-start;\n                    align-items: stretch;\n                 "));
    }
  }

  return styles;
}; // fillContainer style


var fillStyle = function fillStyle(fillProp) {
  if (fillProp === "horizontal") return "width: 100%;";
  if (fillProp === "vertical") return "height: 100%;";
  if (fillProp) return " width: 100%; height: 100%;";
  return undefined;
}; // generate grid classNames


var generateNameTail = function generateNameTail(text) {
  return "".concat(text.split("-")[0], "-").concat(text.split("-")[1]);
};

var generateGridClasses = function generateGridClasses(grid) {
  return Object.keys(grid).reduce(function (acc, size) {
    if (typeof grid[size] === "string") {
      return [].concat(_toConsumableArray(acc), ["c-span-".concat(size, "-").concat(generateNameTail(grid[size]))]);
    }

    if (_typeof(grid[size]) === "object") {
      var names = Object.keys(grid[size]).reduce(function (names, cur) {
        return [].concat(_toConsumableArray(names), ["c-".concat(cur, "-").concat(size, "-").concat(generateNameTail(grid[size][cur]))]);
      }, []);
      return [].concat(_toConsumableArray(acc), _toConsumableArray(names));
    }
  }, []);
};

var StyledBox = (0, _styledComponents["default"])(function (_ref) {
  var grid = _ref.grid,
      className = _ref.className,
      _ref$Component = _ref.Component,
      Component = _ref$Component === void 0 ? "div" : _ref$Component,
      onClick = _ref.onClick,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      children = _ref.children,
      innerRef = _ref.innerRef,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = (0, _classnames["default"])(grid && generateGridClasses(grid), className);
  return /*#__PURE__*/React.createElement(Component, _extends({
    onClick: onClick,
    onBlur: onBlur,
    onFocus: onFocus,
    className: classes,
    ref: innerRef
  }, props), children);
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), function (props) {
  return props.align && alignStyle(props.align);
}, function (props) {
  return props.alignContent && alignContentStyle(props.alignContent);
}, function (props) {
  return props.background && (0, _utils.backgroundStyle)(props.background, props.theme);
}, function (props) {
  return props.direction && directionStyle(props.direction, props.theme);
}, function (props) {
  return props.fill && fillStyle(props.fill);
}, function (props) {
  return props.flex && "display:flex";
}, function (props) {
  return props.width && "height:".concat(props.height, "px");
}, function (props) {
  return props.justify && justifyStyle(props.justify);
}, function (props) {
  return props.margin && "margin:".concat(props.margin, "px");
}, function (props) {
  return props.padding && "padding:".concat(props.padding, "px");
}, function (props) {
  return props.wrap && "flex-wrap:".concat(props.wrap);
}, function (props) {
  return props.width && "width:".concat(props.width, "px");
});
StyledBox.defaultProps = {
  flex: true
};
var _default = StyledBox;
exports["default"] = _default;